import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  label: string;
  value: string;
}

export const ApprovalTermRow = ({ label, value }: Props) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      py: 1.5,
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Typography variant="body1">{label}</Typography>
    <Typography variant="body1">{value}</Typography>
  </Box>
);
